<div class="col-12">
        <p-button label="Associate to a Company"  (click)="navigateToCompanyAssociationRequest()" class="mr-1"></p-button>
        <p-button label="Create New Company"  (click)="navigateToNewCompanyRequest()"></p-button>
    </div>
